import { apiExpress, options as defaultHeaders } from 'lib/config';
import axios from 'axios';

export const getYoutubeAuthUrl = async () => {
  const { bearerToken: headers } = defaultHeaders;

  try {
    const response = await axios({
      baseURL: apiExpress,
      url: '/youtube/auth-url',
      method: 'GET',
      headers,
      data: {
        from: 'covideo',
      },
    });
    return await response.data;
  } catch (error) {
    console.log(error);
  }
};

export const checkYoutubeIntegration = async () => {
  const { bearerToken: headers } = defaultHeaders;

  try {
    const response = await axios({
      baseURL: apiExpress,
      url: '/youtube/integration',
      method: 'GET',
      headers,
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getChannelData = async () => {
  const { bearerToken: headers } = defaultHeaders;

  try {
    const response = await axios({
      baseURL: apiExpress,
      url: '/youtube/channel',
      method: 'GET',
      headers,
    });
    return await response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getVideoAnalytics = async (id: number) => {
  const { bearerToken: headers } = defaultHeaders;

  try {
    const response = await axios({
      baseURL: apiExpress,
      url: `/youtube/video/${id}/analytics`,
      method: 'GET',
      headers,
    });
    return await response.data;
  } catch (error) {
    console.log(error);
  }
};

export const saveYoutubeAccessToken = async (code: string) => {
  const { bearerToken: headers } = defaultHeaders;

  try {
    const response = await axios({
      baseURL: apiExpress,
      url: '/youtube/token',
      method: 'POST',
      headers,
      data: {
        code,
      },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const savePrivacySetting = async (privacy: string) => {
  const { bearerToken: headers } = defaultHeaders;

  try {
    const response = await axios({
      baseURL: apiExpress,
      url: '/youtube/privacy',
      method: 'PATCH',
      headers,
      data: {
        privacy,
      },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const uploadVideo = async (
  videoId: string,
  title: string,
  description: string
) => {
  const { bearerToken: headers } = defaultHeaders;

  try {
    const response = await axios({
      baseURL: apiExpress,
      url: '/youtube/share-video',
      method: 'POST',
      headers,
      data: {
        title,
        description,
        videoId,
      },
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const deleteIntegration = async () => {
  const { bearerToken: headers } = defaultHeaders;

  try {
    const response = await axios({
      baseURL: apiExpress,
      url: '/youtube/integration',
      method: 'DELETE',
      headers,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};
